import {
    InMemoryCache,
    IntrospectionFragmentMatcher,
    defaultDataIdFromObject,
} from "apollo-cache-inmemory";
import { initialLocalState } from "../config/apollo/data";
import introspectionQueryResultData from "./fragmentTypes.json";
import { QUERY_UI } from "./queries/local";

const fragmentMatcher = new IntrospectionFragmentMatcher({
    introspectionQueryResultData,
});

const defaultUi = {
    asideHover: false,
    asideMinimize: true,
    asideToggle: false,
    headerToggle: false,
};

export const createApolloCache = () => {
    const cache = new InMemoryCache({
        fragmentMatcher: fragmentMatcher,
        dataIdFromObject: object => {
            switch (object.__typename) {
                case "LineItem":
                    return `${Math.random().toString(36).slice(-5)}-${
                        object.id
                    }`;
                case "Variant":
                    return `${Math.random().toString(36).slice(-5)}-${
                        object.id
                    }`;
                case "OrderDiscountItem":
                    return `${Math.random().toString(36).slice(-5)}-${
                        object.id
                    }`;
                // We add these to the cache to avoid the error of overwriting the status from
                // the system app list to the store app list
                case "Stronghold":
                    return `${Math.random().toString(36).slice(-5)}-${
                        object.id
                    }`;
                case "Treez":
                    return `${Math.random().toString(36).slice(-5)}-${
                        object.id
                    }`;
                case "AlpineIQ":
                    return `${Math.random().toString(36).slice(-5)}-${
                        object.id
                    }`;
                case "Berbix":
                    return `${Math.random().toString(36).slice(-5)}-${
                        object.id
                    }`;
                case "Redirect":
                    return `${Math.random().toString(36).slice(-5)}-${
                        object.id
                    }`;
                case "Klaviyo":
                    return `${Math.random().toString(36).slice(-5)}-${
                        object.id
                    }`;
                case "QuickBook":
                    return `${Math.random().toString(36).slice(-5)}-${
                        object.id
                    }`;
                case "MinZipByCode":
                    return `${Math.random().toString(36).slice(-5)}-${
                        object.id
                    }`;
                case "Omnisend":
                    return `${Math.random().toString(36).slice(-5)}-${
                        object.id
                    }`;
                case "OnFleet":
                    return `${Math.random().toString(36).slice(-5)}-${
                        object.id
                    }`;
                case "Feefo":
                    return `${Math.random().toString(36).slice(-5)}-${
                        object.id
                    }`;
                case "Iterable":
                    return `${Math.random().toString(36).slice(-5)}-${
                        object.id
                    }`;
                case "ListTrack":
                    return `${Math.random().toString(36).slice(-5)}-${
                        object.id
                    }`;
                case "IDScan":
                    return `${Math.random().toString(36).slice(-5)}-${
                        object.id
                    }`;
                case "Dutchie":
                    return `${Math.random().toString(36).slice(-5)}-${
                        object.id
                    }`;
                case "Aeropay":
                    return `${Math.random().toString(36).slice(-5)}-${
                        object.id
                    }`;
                case "Surfside":
                    return `${Math.random().toString(36).slice(-5)}-${
                        object.id
                    }`;
                case "TreezPay":
                    return `${Math.random().toString(36).slice(-5)}-${
                        object.id
                    }`;
                case "Metafield":
                    return `${Math.random().toString(36).slice(-5)}-${
                        object.id
                    }`;
                case "Jane":
                    return `${Math.random().toString(36).slice(-5)}-${
                        object.id
                    }`;
                case "Sticky":
                    return `${Math.random().toString(36).slice(-5)}-${
                        object.id
                    }`;
                default:
                    return defaultDataIdFromObject(object);
            }
        },
    });

    cache.writeData(initialLocalState);

    return cache;
};

export const apolloResolvers = {
    Mutation: {
        updateUi: (_, args, { cache }) => {
            let previous = defaultUi;
            try {
                const cached = cache.readQuery({ query: QUERY_UI });
                if (cached?.ui) {
                    previous = { ...defaultUi, ...cached.ui };
                }
            } catch (_err) {
                // Cold cache — fall back to defaults.
            }

            const ui = {
                ...previous,
                ...args.ui,
                __typename: "Ui",
            };

            cache.writeData({ data: { ui } });
            cache.writeQuery({
                query: QUERY_UI,
                data: { ui },
            });

            return null;
        },
    },
};
